module.exports = __webpack_public_path__ + "img/cloudy-night.24d24529.gif";